/**
 * «هر بار که این بخش دیده شد، داده را تازه کن» (v2.167.0).
 *
 * کاربر (۱۴۰۵/۰۸/۰۹): «مانده و وضعیت حساب دکمهٔ بازخوانی دارد ولی وقتی روی صفحه می‌آییم باید خودش به‌روز شود؛ فاکتوری زده بودم
 * و هنوز نیامده بود». ریشه: تب‌های antd بعد از اولین نمایش زنده می‌مانند ⇒ `useEffect([load])` فقط یک بار اجرا می‌شد.
 * حالا: (۱) هر بار که تب دوباره فعال شود، (۲) هر بار که پنجره/تبِ مرورگر دوباره در جلو بیاید — بارگذاریِ تازه.
 * `minGapMs` جلوی بارگذاریِ پشتِ‌سرِهم (فوکوس + visibilitychange با هم) را می‌گیرد.
 */
import { useEffect, useRef } from "react";

export default function useRefreshOnShow(load, active = true, minGapMs = 3000) {
  const last = useRef(0);
  const wasActive = useRef(active);
  const fn = useRef(load);
  fn.current = load;

  const run = () => {
    const now = Date.now();
    if (now - last.current < minGapMs) return;
    last.current = now;
    if (fn.current) fn.current();
  };

  // تب دوباره فعال شد ⇒ تازه (اولین نمایش را `useEffect`ِ خودِ صفحه انجام می‌دهد)
  useEffect(() => {
    if (active && !wasActive.current) run();
    wasActive.current = active;
  }, [active]);

  // برگشت به پنجره/تبِ مرورگر
  useEffect(() => {
    if (!active) return undefined;
    const onShow = () => { if (document.visibilityState === "visible") run(); };
    window.addEventListener("focus", onShow);
    document.addEventListener("visibilitychange", onShow);
    return () => {
      window.removeEventListener("focus", onShow);
      document.removeEventListener("visibilitychange", onShow);
    };
  }, [active]);
}
